import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IBalanceTimeline {
    balance: TimelineGraph[]
    order: TimelineGraph[]
}

export interface TimelineGraph {
    timestamp: number
    amount: number
}

export const getBalanceTimeline = async (order_id: string): Promise<ApiRes<IBalanceTimeline>> => {
    return await apiGet(API_URL, `admin/unknown/${order_id}`)
}
